// extracted by mini-css-extract-plugin
module.exports = {"summary":"MealsSummary_summary__phqC9","nav":"MealsSummary_nav__2VeHE","active":"MealsSummary_active__UYoV4"};